export { default } from './AutomationScoreSlider';
